export const createLanguageSwitcher = (element) => {
  const instance = {
    $element: null,
    $modal: null,
    $closeButton: null,

    init(element) {
      this.$element = jQuery(element);
      this.$modal = jQuery("#language-modal");
      this.$closeButton = this.$modal.find(".js-language-modal-close");

      this.setEventListeners();
    },

    setEventListeners() {
      // Open modal on language switcher click
      this.$element.on("click", () => {
        this.openModal();
      });

      // Close modal on close button click
      this.$closeButton.on("click", () => {
        this.closeModal();
      });

      // Close modal on outside click
      this.$modal.on("click", (event) => {
        if (jQuery(event.target).closest(".rounded-lg").length === 0) {
          this.closeModal();
        }
      });

      // Close modal on escape key
      jQuery(document).on("keydown", (event) => {
        if (event.key === "Escape" && !this.$modal.hasClass("hidden")) {
          this.closeModal();
        }
      });
    },

    openModal() {
      this.$modal.removeClass("hidden");
      document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
    },

    closeModal() {
      this.$modal.addClass("hidden");
      document.body.style.overflow = ""; // Restore scrolling
    },
  };

  instance.init(element);
  return instance;
};
